import React, { useState } from 'react';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import InputCheckBox from '../../../../../../components/NovoSistema/InputCheckBox';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import { WrapperLegendItens } from '../../../../../../components/NovoSistema/WrapperLegendItens';
import HeaderButtons from '../../../../../../components/NovoSistema/HeaderButtons';
import ButtonOptions from '../../../../../../components/NovoSistema/ButtonOptions';

export default function PedidoDeCompraAdd({ setOption }) {
  const [internalOption, setInternalOption] = useState('principal');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Principal"
          border="#333F50"
          active={internalOption === 'principal' ? true : false}
          yourFunction={() => setInternalOption('principal')}
        />
        <ButtonOptions
          buttonName="Itens"
          border="#333F50"
          active={internalOption === 'itens' ? true : false}
          yourFunction={() => setInternalOption('itens')}
        />
        <ButtonOptions
          buttonName="Transporte"
          border="#333F50"
          active={internalOption === 'transport' ? true : false}
          yourFunction={() => setInternalOption('transport')}
        />
        <ButtonOptions
          buttonName="Vencimento"
          border="#333F50"
          active={internalOption === 'dueDate' ? true : false}
          yourFunction={() => setInternalOption('dueDate')}
        />
        <ButtonOptions
          buttonName="Observações"
          border="#333F50"
          active={internalOption === 'observation' ? true : false}
          yourFunction={() => setInternalOption('observation')}
        />
      </HeaderButtons>
      {internalOption === 'principal' && (
        <div>
          <ContainerSection>
            <h3>Dados da Nota</h3>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Número" id="Numero" widthPercentage="20%" />
                <InputDate title="Data de Emissão" id="DataDeEmissao" widthPercentage="20%" />
                <InputDate title="*Data de Entrega" id="DatadeEntrega" widthPercentage="20%" />
                <InputText title="Situação" id="Situacao" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="*Parceiro de Negócios" id="ParceiroDeNegocios" widthPercentage="47%" />
                <InputText title="Município" id="Municipio" widthPercentage="20%" />
                <InputText title="UF" id="UF" widthPercentage="20%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'itens' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Produto" id="Produto" widthPercentage="20%" />
                <InputText title="Un." id="Unidade" widthPercentage="20%" />
                <InputText title="Saldo Estoque" id="SaldoEstoque" widthPercentage="20%" />
                <InputText title="IPI(%)" id="IPI" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="*Qtde" id="Qtde" widthPercentage="15%" />
                <InputText title="*Vlr. Unitário" id="VlrUnitario" widthPercentage="15%" />
                <InputText title="Desconto(%)" id="DescontoPercentage" widthPercentage="15%" />
                <InputText title="Desconto" id="Desconto" widthPercentage="15%" />
                <InputText title="ICMS(%)" id="ICMSPercentage" widthPercentage="15%" />
                <InputText title="ICMS ST" id="ICMSST" widthPercentage="15%" />
              </WrapperInputsNewSystem>
              <ButtonsGeneric>
                <button className="success">+ Adicionar</button>
              </ButtonsGeneric>
            </div>
          </ContainerSection>
          <ContainerSection>
            <h3>Legenda</h3>
            <WrapperLegendItens>
              <li>Cadastrado</li>
              <li>Recebido Parcial</li>
              <li>Recebido Total</li>
            </WrapperLegendItens>
          </ContainerSection>
          <ContainerSection>
            <h3>Totais dos Itens</h3>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Frete" id="Frete" widthPercentage="20%" />
                <InputText title="Seguro" id="Seguro" widthPercentage="20%" />
                <InputText title="Outras Despesas" id="OutrasDespesas" widthPercentage="20%" />
                <InputText title="Desconto" id="DescontoTotaisItens" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="ICMS ST" id="ICMSSTTotaisItens" widthPercentage="20%" />
                <InputText title="IPI(%)" id="IPITotaisItens" widthPercentage="20%" />
                <InputText title="Desconto Produtos" id="DescontoProdutos" widthPercentage="20%" />
                <InputText title="Total dos Produtos" id="TotalDosProdutos" widthPercentage="20%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'transport' && (
        <div>
          <ContainerSection>
            <h3>Tipo Entrega</h3>
            <div>
              <SelectAndOptions
                title="Tipo Entrega"
                id="TipoEntrega"
                optionsArray={[
                  '',
                  'Cliente Retira',
                  'Correios',
                  'Comprador Retira',
                  'Entregador Autônomo',
                  'Entregador Próprio',
                  'Transportadora',
                  'Veículo Próprio',
                  'Empresa de Entregas',
                ]}
                widthPercentage="50%"
              />
            </div>
          </ContainerSection>
          <ContainerSection>
            <h3>Transportadora</h3>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Código" id="CodigoTransportadora" widthPercentage="40%" />
                <SelectAndOptions
                  title="Tipo Entrega"
                  id="TipoEntrega"
                  optionsArray={[
                    '',
                    '0 - Contratação do Frete por conta do remetente (CIF)',
                    '1 - Contratação do Frete por conta do Destinatário (FOB)',
                    '2 - Contratação do Frete por conta de Terceiros',
                    '3 - Transporte Próprio por conta do Remetente',
                    '4 - Transporte Próprio por conta do Destinatário',
                    '9 - Sem ocorrência de Transporte',
                  ]}
                  widthPercentage="40%"
                />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'dueDate' && (
        <div>
          <ContainerSection>
            <h3>Dados Vencimento</h3>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Forma de Pagamento"
                  id="FormaDePagamento"
                  optionsArray={[
                    '',
                    'Novo...',
                    'Dinheiro',
                    'Cheque',
                    'Cartão Drédito',
                    'Cartão Débito',
                    'Transferência DOC',
                    'Transferência TED',
                    'Boleto',
                    'Voucher',
                    'Troca',
                    'Conta',
                    'Débito Automático',
                  ]}
                  widthPercentage="20%"
                />
                <InputText title="Qtde. Parcelas" id="QtdeParcelas" widthPercentage="20%" />
                <InputText title="Abatimento" id="Abatimento" widthPercentage="20%" />
                <InputText title="Acréscimo" id="Acrescimo" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Intervalo"
                  id="Intervalo"
                  optionsArray={[
                    '',
                    'Mensal',
                    'Semanal',
                    'Quinzenal',
                    'Variável (A definir)',
                    'Dia Fixo',
                    '1º dia útil do mês',
                    'Último dia do mês',
                  ]}
                  widthPercentage="20%"
                />
                <InputText title="Dia Fixo" id="DiaFixo" widthPercentage="20%" />
                <InputCheckBox title="À vista" id="Avista" />
                <InputCheckBox title="Com entrada" id="ComEntrada" />
              </WrapperInputsNewSystem>
              <ButtonsGeneric>
                <button className="success">Calcular</button>
              </ButtonsGeneric>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'observation' && (
        <div>
          <ContainerSection>
            <h3>Observações</h3>
            <div>
              <textarea name="Observation" id="observation" cols="100" rows="3"></textarea>
              <p>Máximo de 500 caracteres.</p>
            </div>
          </ContainerSection>
          <ContainerSection>
            <h3>Anexos</h3>
            <WrapperLegendItens>
              <input type="file" name="attachments" id="attachments" />
            </WrapperLegendItens>
          </ContainerSection>
        </div>
      )}

      <ContainerSection>
        <h3>Totais</h3>
        <div>
          <WrapperInputsNewSystem>
            <InputText title="Total Financeiro" id="TotalFinanceiro" widthPercentage="40%" />
            <InputText title="Total do Pedido" id="TotalDoPedido" widthPercentage="40%" />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
